import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import i18n from "../../../../i18n";
import { addModal } from "../../../../app.logic";
import { modalStyleForm } from "../../../../utils/constant";
import { initUseForm } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { required, validateError } from "../../../../utils/validate";
import { createFieldTextArea } from "../../../../components/input/template-builder/template-builder.logic";

export const { isLoading, setIsLoading } = createLoading();

export const NotApproveRequestForm = defineAsyncComponent(() => import("./NotApproveRequestForm"));

export const openModalForm = ({ props, onOk, bind }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.register.notApprove.title"),
                width: "500px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <NotApproveRequestForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></NotApproveRequestForm>
        )
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        remark: null
    };
};

export const createRules = () => {
    return {
        remark: [required],
        };
};

export const createField = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    return [
        createFieldTextArea({
            key: "remark",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t("model.register.remark"),
            inputProp: () => {
                return {
                    value: modelRef.remark,
                    "onUpdate:value": value => (modelRef.remark = value),
                };
            }
        })
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
